<template>
        <v-client-table
                :data="tableData"
                :columns="columns"
                :options="options"
                >
            <spring-spinner
                    slot="loading"
                    :animation-duration="2500"
                    :size="70"
                    color="#4ae387"
                    class="spinner"
            />
        </v-client-table>
</template>

<script>
    import axios from 'axios/index'
    import { ClientTable } from 'vue-tables-2'
    import SpringSpinner from "epic-spinners/src/components/lib/SpringSpinner";
    export default {
        name: "datatable",
        components:{SpringSpinner, ClientTable},
        data(){
            return{
                columns:['id','proveedor','fecha',
                'fecha_recepcion','tipo','condicion_pago',
                'atencion_a','estado'],
                tableData:[],
                proveedores:[],
                options:{
                    headings:{
                        id:'Folio',
                        fecha:'Fecha',
                        fecha_recepcion:'Fecha Recepcion',
                        tipo:'Tipo',
                        condicion_pago:'Condicion Pago',
                        atencion_a:'Atencion A',
                        estado:'Estado',
                        acciones:''



                    },
                    sortable:['id','nombre','fecha'],
                    filterable: ['id', 'nombre','fecha']
                }

            }
        },
        created() {
            const self = this;
            axios.get('http://192.168.0.186/api/compras')
                .then(function (response) {
                    self.tableData = response.data

                })
        }
    }
</script>

<style scoped>
</style>